/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlackUser
 */
export interface SlackUser {
    /**
     * 
     * @type {string}
     * @memberof SlackUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SlackUser
     */
    name: string;
}

export function SlackUserFromJSON(json: any): SlackUser {
    return SlackUserFromJSONTyped(json, false);
}

export function SlackUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function SlackUserToJSON(value?: SlackUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


